export default "/assets/site/images/si.jpg?23a6477595215801ee70fccaf3ad0b58";